import { FiCheck, FiChevronDown } from "react-icons/fi";
import { parseJwt } from "../pages/Dashboard/Dashboard";
import { useState } from "react";
import { useTeamService } from "../api/teamService";
import { useAuthService } from "../api/authService";
import { Team } from "@quantizr-engineering/common/types/team";
import { User } from "@quantizr-engineering/common/types/user";

const TeamSelector: React.FC<{ collapsed?: boolean }> = ({
  collapsed = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const token = localStorage.getItem("authToken");
  const user: User = parseJwt(token || "");
  const { teamsForMember } = useTeamService();
  const { switchTeam } = useAuthService();

  const handleTeamSelection = (team: Team) => {
    // Same team, don't bother refreshing data
    if (team.id === user.teamID) {
      return;
    }
    // localStorage.setItem("selectedTeam", JSON.stringify(team));
    switchTeam(team.id);
  };

  return (
    <div className="relative mt-4">
      <div
        className={`flex flex-row transition-none items-center ${
          teamsForMember && teamsForMember.length > 1
            ? "hover:bg-gray-100 cursor-pointer"
            : ""
        }`}
        onClick={() =>
          teamsForMember && teamsForMember.length > 1
            ? setIsOpen(!isOpen)
            : undefined
        }
      >
        <div className="bg-purple-200 text-purple-900 h-10 w-10 flex items-center justify-center rounded-full">
          {user?.teamName?.slice(0, 1).toUpperCase() ?? ""}
        </div>
        <div
          className={`pl-2 text-gray-700 flex-1 min-w-0 flex items-center justify-between ${
            collapsed ? "hidden" : "block"
          }`}
        >
          <div className="font-bold text-gray-900 text-left truncate">
            {user.teamName}
          </div>
          {teamsForMember && teamsForMember.length > 1 && (
            <div className="mr-4">
              <FiChevronDown />
            </div>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="absolute mt-1 w-full bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
          {teamsForMember?.map((team) => (
            <div
              key={team.id}
              onClick={() => {
                handleTeamSelection(team);
                setIsOpen(false);
              }}
              className="flex items-center px-4 py-2 hover:bg-purple-100 cursor-pointer transition-colors duration-200"
            >
              <div className="flex items-center w-full">
                {user.teamName === team.name && (
                  <FiCheck className="h-5 w-5 text-purple-600 mr-2" />
                )}
                <span
                  className={`block truncate ${
                    user.teamName === team.name
                      ? "font-medium text-purple-900"
                      : "font-normal text-gray-900"
                  }`}
                >
                  {team.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamSelector;
